// Tracks that this browser session was opened from the mobile app, so
// post-donation screens can offer a way back.
const KEY = 'claritas.fromApp'

export const APP_RETURN_URL_SIGNED_IN = 'claritas://profile/pastDonations'
export const APP_RETURN_URL_GUEST = 'claritas://'

export function markCameFromApp() {
  try {
    window.sessionStorage.setItem(KEY, '1')
  } catch {
    // storage unavailable; ignore
  }
}

export function cameFromApp() {
  try {
    return window.sessionStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}
